(function () {

    angular.module('tmx-app').service('fileUpload', ['$http', 'APP_CONSTANTS', function ($http, APP_CONSTANTS) {

        var uploadFile = this;
        uploadFile.upload = upload;

        function upload(file, uploadUrl, headers,responseType) {

            var fd = new FormData();
            fd.append('file', file);
            return $http.post(APP_CONSTANTS.backend + uploadUrl, fd, {
                transformRequest: angular.identity,
                responseType:responseType?responseType:undefined,
                headers: headers ? headers : { 'Content-Type': undefined }
            });
        }
    }]);
})();